import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Navigation } from "@/components/Navigation";
import { Button } from "@/components/ui/button";
import { Particles } from "@/components/Particles";
import { AgeRestrictionModal } from "@/components/AgeRestrictionModal";
import { useAuth } from "@/contexts/AuthContext";
import { useCredits } from "@/contexts/CreditsContext";
import { PricingModal } from "@/components/PricingModal";
import { Sparkles } from "lucide-react";
import { GalleryFAQ } from "@/components/GalleryFAQ";
import { AppSidebar } from "@/components/AppSidebar";
import GalleryImageItem from "@/components/GalleryImageItem";
import GalleryVideoItemWrapper from "@/components/GalleryVideoItemWrapper";
import ImagePopup from "@/components/ImagePopup";
import LoginPromptModal from "@/components/LoginPromptModal";

import { LegalDisclaimer } from "@/components/LegalDisclaimer";
import { Footer } from "@/components/Footer";

// Session storage keys for popup shown state - separate for each image type
const POPUP_SHOWN_KEYS = {
  realistic: "gallery_popup_realistic_shown",
  anime: "gallery_popup_anime_shown",
  render: "gallery_popup_render_shown",
} as const;
// Import all gallery images

// Videos will be added here in the future

// Array of realistic images
const realisticImages = [
  "https://assets.loverslabs.art/Galeria01/hfhfghfdghfh.jpg",
  "https://assets.loverslabs.art/Galeria01/fhfjgfjgfjhgh.jpg",
  "https://assets.loverslabs.art/Galeria01/gdfgdfghfhfg.avif",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd16.jpg",
  "https://loverslabs.art/assets/image-05-b1JZE9ly.jpg",
  "https://assets.loverslabs.art/Galeria01/hshfdghdghdfhf.jpg",
  "https://loverslabs.art/assets/image-07-BR6e9J36.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecdhthdrth.jpg",
  "https://assets.loverslabs.art/Galeria01/hfghfhgfh.jpg",
  "https://loverslabs.art/assets/image-10-DaLezodE.jpg",
  "https://loverslabs.art/assets/image-11-3jPUsLcp.jpg",
  "https://assets.loverslabs.art/Galeria01/NeRCZSyr0kTSsLfmT4S4.jpg",
  "https://assets.loverslabs.art/Galeria01/fghfghfghfghf.avif",
  "https://assets.loverslabs.art/TbxfZrnfoDSIRep3Bj57.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd17.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd5.jpg",
  "https://loverslabs.art/assets/image-17-DSQT8fwc.jpg",
  "https://loverslabs.art/assets/image-18-DNltggqK.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd6.jpg",
  "https://assets.loverslabs.art/Galeria01/fghfghfhfhfhf.avif",
  "https://assets.loverslabs.art/Galeria01/fhfhfhfgnffnfg.jpg",
  "https://loverslabs.art/assets/image-22-D_MlFhAQ.jpg",
  "https://loverslabs.art/assets/image-23-B9zfke61.jpg",
  "https://loverslabs.art/assets/image-24-BA0oHlq6.jpg",
  "https://assets.loverslabs.art/Galeria01/gdfgdgfxgfxg.jpg",
  "https://loverslabs.art/assets/image-26-CfW8cnVM.jpg",
  "https://loverslabs.art/assets/image-27-BijdX1zG.jpg",
  "https://loverslabs.art/assets/image-28-ddx-7dEE.jpg",
  "https://loverslabs.art/assets/image-29-j-CaEK1_.jpg",
  "https://loverslabs.art/assets/image-30-CLyKmdTy.jpg",
  "https://loverslabs.art/assets/image-31-NoPOBe5T.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd8.jpg",
  "https://loverslabs.art/assets/image-33-C_nSyc-t.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd9.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd10.jpg",
  "https://assets.loverslabs.art/Galeria01/fsefsfsfsdfs.avif",
  "https://loverslabs.art/assets/image-37-D1J2V8t3.jpg",
  "https://loverslabs.art/assets/image-38-OcLgN0Dn.jpg",
  "https://loverslabs.art/assets/image-39-DcnNlFeL.jpg",
  "https://loverslabs.art/assets/image-40-CtXeyv0m.jpg",
  "https://assets.loverslabs.art/Galeria01/fgxdfgxfdgxfg.jpg",
  "https://loverslabs.art/assets/image-42-CrCmLcXQ.jpg",
  "https://assets.loverslabs.art/Galeria01/dfgfhfghfgh.jpg",
  "https://loverslabs.art/assets/image-44-CehajzBU.jpg",
  "https://loverslabs.art/assets/image-45-D-QhI4Cz.jpg",
  "https://loverslabs.art/assets/image-46-CesQdWa9.jpg",
  "https://loverslabs.art/assets/image-47-DXQaXO_g.jpg",
  "https://assets.loverslabs.art/Galeria01/ghfdhfhrh.jpg",
  "https://loverslabs.art/assets/image-49-C08JBnuW.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd11.jpg",
  "https://loverslabs.art/assets/image-51-Cfulzhoo.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd12.jpg",
  "https://loverslabs.art/assets/image-53-CjtYUBG_.jpg",
  "https://assets.loverslabs.art/Galeria01/TscJb17v0gJQrq0wTjJv.jpg",
  "https://loverslabs.art/assets/image-55-zWRBdOfV.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd13.jpg",
  "https://assets.loverslabs.art/Galeria01/OwCsTx05A9JEO2EpWko0.jpg",
  "https://loverslabs.art/assets/image-58-C3ASn5lv.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd14.jpg",
  "https://loverslabs.art/assets/image-60-DG2K9W_A.jpg",
  "https://loverslabs.art/assets/image-61-NLFtNf7J.jpg",
  "https://loverslabs.art/assets/image-62-DhKchgAi.jpg",
  "https://loverslabs.art/assets/image-63-CMcGZWrB.jpg",
  "https://loverslabs.art/assets/image-64-DhXoDG8R.jpg",
  "https://loverslabs.art/assets/image-65-DtuLWL35.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd15.jpg",
  "https://loverslabs.art/assets/image-67-B10BQnEv.jpg",
  "https://loverslabs.art/assets/image-68-cWYb-QKA.jpg",
  "https://loverslabs.art/assets/image-69-D6UwWnWk.jpg",
  "https://assets.loverslabs.art/DdlOmKazk3OS1Iueb6mn.jpg",
  "https://loverslabs.art/assets/image-71-BbtVXFXA.jpg",
  "https://loverslabs.art/assets/image-72-D-AdZIPR.jpg",
  "https://loverslabs.art/assets/image-73-DTmyI8qo.jpg",
  "https://assets.loverslabs.art/Galeria01/1yjzpqewat.ucarecddfgdfg.jpg",
  "https://loverslabs.art/assets/image-75-DGThrTtf.jpg",
  "https://loverslabs.art/assets/image-76-CPNeJ5m2.jpg",
  "https://loverslabs.art/assets/image-77-Cry2oF3X.jpg",
  "https://loverslabs.art/assets/image-78-9VyJ50Q5.jpg",
  "https://assets.loverslabs.art/Galeria01/1yjzpqewat.ucarecd.jpg",
  "https://assets.loverslabs.art/Galeria01/5i86fiuukt.ucarecd19.jpg",
  "https://loverslabs.art/assets/image-81-BLWTer8A.jpg",
  "https://loverslabs.art/assets/image-82-D_BVB_m6.jpg",
  "https://assets.loverslabs.art/Galeria01/dfsdfsfdgfdgf.jpg",
  "https://assets.loverslabs.art/Galeria01/dsfsdfdsfdsf.jpg",
  "https://loverslabs.art/assets/image-85-BLotcOD_.jpg",
  "https://loverslabs.art/assets/image-86-DdQb5mcl.jpg",
  "https://loverslabs.art/assets/image-87-3_tvetHr.jpg",
  "https://loverslabs.art/assets/image-88-B_i02aCv.jpg",
  "https://loverslabs.art/assets/image-89-BIqDzYCr.jpg",
  "https://loverslabs.art/assets/image-90-eeMff6rU.jpg",
  "https://loverslabs.art/assets/image-91-Dbuu1Gqx.jpg",
  "https://loverslabs.art/assets/image-92-Dc1abjYO.jpg",
  "https://loverslabs.art/assets/image-93-BLC_yb62.jpg",
  "https://loverslabs.art/assets/image-94-CrAW4Q9C.jpg",
  "https://loverslabs.art/assets/image-95-D8V9F13r.jpg",
  "https://loverslabs.art/assets/image-96-1eulB3-T.jpg",
  "https://loverslabs.art/assets/image-97-XP1oyK5b.jpg",
  "https://loverslabs.art/assets/image-98-hU5TrWwV.jpg",
  "https://loverslabs.art/assets/image-99-C-l5VGfI.jpg",
  "https://loverslabs.art/assets/image-100-BnzJwZCv.jpg",
];

// Array of anime images
const animeImages = [
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd40.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd41.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd39.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd38.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd37.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd36.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd35.jpg",
  "https://assets.loverslabs.art/anime/anime/XuezIPeMfICMGaVMu6oC.jpg",
  "https://assets.loverslabs.art/anime/anime/ypMOWG7lHZepZCBnFxR2.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd32.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd48.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd47.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd46.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd45.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd44.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd43.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd42.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd7.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd6.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd52.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd51.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd50.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd5.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd49.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecdffdf.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd9.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd8.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd4.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd3.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd29.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd28.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd27.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd26.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd25.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd23.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd10.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd11.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd12.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd13.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd14.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd16.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd17.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd19.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd2.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd20.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd21.jpg",
  "https://assets.loverslabs.art/anime/anime/anime%202/anime%202/w2xfbxnhdp.ucarecd22.jpg",
  "https://assets.loverslabs.art/anime/anime/w2xfbxnhdp.ucarecd54.jpg",
  "https://assets.loverslabs.art/anime/anime/w2xfbxnhdp.ucarecd53.jpg",
  "https://assets.loverslabs.art/anime/anime/w2xfbxnhdp.ucarecd55.jpg",
];

// Array of render images
const renderImages = [
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd9.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd7.jpg",
  "https://assets.loverslabs.art/Galeria01/XizUroQyDiFSA8ZQhJpm.jpg",
  "https://assets.loverslabs.art/render/F9dw00vB47MARJtjRHDS.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd56.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd55.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd54.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd52.jpg",
  "https://assets.loverslabs.art/render/hcKJjEfJzrC9iB3PXnrp.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd50.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd5.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd49.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd48.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd47.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd46.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd44.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd43.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd42.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd41.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd40.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd4.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd38.jpg",
  "https://assets.loverslabs.art/render/Uy1P1TnF0pdNKMekptAk.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd35.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd34.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd33.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd32.jpg",
  "https://assets.loverslabs.art/render/5i86fiuukt.ucarecd.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd30.jpg",
  "https://assets.loverslabs.art/render/1yjzpqewat.jpg",
  "https://assets.loverslabs.art/render/OqbNDN9Bpq3v34vx8Coc.jpg",
  "https://assets.loverslabs.art/render/gMGkeGHQKpxolyis9kpX.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd26.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd25.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd24.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd22.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd21.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd20.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd2.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd19.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd17.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd16.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd15.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd14.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd13.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd12.jpg",
  "https://assets.loverslabs.art/render/render%202/w2xfbxnhdp.ucarecd10.jpg",
  "https://assets.loverslabs.art/render/OFDHdHejRAAxwKtsoSmr.jpg",
  "https://assets.loverslabs.art/render/render%202/4.jpg",
  "https://assets.loverslabs.art/render/render%202/5.jpg",
];

// Array of all videos
const galleryVideos = [
  "https://assets.loverslabs.art/galeria-videos/web_optimized1.mp4",
  "https://assets.loverslabs.art/galeria-videos/02.mp4",
  "https://assets.loverslabs.art/videos/web_optimized123.mp4",
  "https://assets.loverslabs.art/galeria-videos/web_optimized4.mp4",
  "https://assets.loverslabs.art/videos/05.mp4",
  "https://assets.loverslabs.art/galeria-videos/video.mp4",
  "https://assets.loverslabs.art/videos/O53gveJg0be5CH3e88n6.mp4",
  "https://assets.loverslabs.art/galeria-videos/video8.mp4",
  "https://assets.loverslabs.art/videos/Sx01dDw4uCxRYdAcSvOPG_video.mp4",
  "https://assets.loverslabs.art/videos/DGJDFGNDFG.mp4",
  "https://assets.loverslabs.art/galeria-videos/01galeriaatual.mp4",
  "https://assets.loverslabs.art/galeria-videos/iaKsGf1ADaRl6rIgaVgS9_WnacBkPp.mp4",
  "https://assets.loverslabs.art/galeria-videos/06.mp4",
  "https://assets.loverslabs.art/galeria-videos/07.mp4",
  "https://assets.loverslabs.art/galeria-videos/08.mp4",
  "https://assets.loverslabs.art/galeria-videos/09.mp4",
  "https://assets.loverslabs.art/galeria-videos/10.mp4",
  "https://assets.loverslabs.art/galeria-videos/11.mp4",
  "https://assets.loverslabs.art/render/web_optimized.mp4",
  "https://assets.loverslabs.art/videos/13.mp4",
  "https://assets.loverslabs.art/galeria-videos/14.mp4",
  "https://assets.loverslabs.art/galeria-videos/15.mp4",
  "https://assets.loverslabs.art/galeria-videos/GDJFGNDF.mp4",
];
const Gallery = () => {
  const { user, loading } = useAuth();
  const { credits } = useCredits();
  const navigate = useNavigate();
  const [ageConfirmed, setAgeConfirmed] = useState(false);
  const [activeTab, setActiveTab] = useState<"images" | "videos">("images");
  const [imageType, setImageType] = useState<"realistic" | "anime" | "render">("realistic");
  const [loadedVideoCount, setLoadedVideoCount] = useState(1);
  const [loadedAnimeCount, setLoadedAnimeCount] = useState(10);
  const [loadedRenderCount, setLoadedRenderCount] = useState(10);
  const [imagesLoaded, setImagesLoaded] = useState<Record<number, boolean>>({});
  const [isPricingOpen, setIsPricingOpen] = useState(false);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [isLoginPromptOpen, setIsLoginPromptOpen] = useState(false);
  const [observerReady, setObserverReady] = useState(false);
  const [loginRedirect, setLoginRedirect] = useState<{ path: string; state?: Record<string, unknown> } | null>(null);

  // State + callback ref para a imagem da 4ª fileira (garante re-observação ao trocar imageType)
  const [fourthRowElement, setFourthRowElement] = useState<HTMLDivElement | null>(null);
  const fourthRowCallback = useCallback((node: HTMLDivElement | null) => {
    setFourthRowElement(node);
  }, []);

  // Estado que indica se algum popup está aberto (para pausar vídeos da galeria)
  const isAnyPopupOpen = isPricingOpen || isImagePopupOpen || isLoginPromptOpen;

  // Show image popup when user scrolls to 4th row - once per session PER IMAGE TYPE
  useEffect(() => {
    // Only observe when ready (after scroll delay) and all conditions are met
    if (activeTab !== "images" || !fourthRowElement || !ageConfirmed || !observerReady) return;

    // Check if this specific type has been shown this session
    const popupKey = POPUP_SHOWN_KEYS[imageType];
    if (sessionStorage.getItem(popupKey)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsImagePopupOpen(true);
          sessionStorage.setItem(popupKey, "true");
          observer.disconnect();
        }
      },
      { threshold: 0.5 },
    );

    observer.observe(fourthRowElement);

    return () => observer.disconnect();
  }, [ageConfirmed, imageType, activeTab, fourthRowElement, observerReady]);

  // Memoize image data with unique IDs
  const imageData = useMemo(
    () => ({
      realistic: realisticImages.map((url, idx) => ({
        id: `realistic-${idx}`,
        url,
        index: idx,
      })),
      anime: animeImages.slice(0, loadedAnimeCount).map((url, idx) => ({
        id: `anime-${idx}`,
        url,
        index: idx,
      })),
      render: renderImages.slice(0, loadedRenderCount).map((url, idx) => ({
        id: `render-${idx}`,
        url,
        index: idx,
      })),
    }),
    [loadedAnimeCount, loadedRenderCount],
  );
  const videoData = useMemo(
    () =>
      galleryVideos.slice(0, loadedVideoCount).map((url, idx) => ({
        id: `video-${idx}`,
        url,
        index: idx,
      })),
    [loadedVideoCount],
  );

  // Get current images with memoization
  const currentImages = useMemo(() => imageData[imageType], [imageData, imageType]);

  // Check age confirmation on mount
  useEffect(() => {
    const confirmed = localStorage.getItem("ageConfirmed") === "true";
    setAgeConfirmed(confirmed);
  }, []);

  // Reset imagesLoaded and scroll to top when switching image type
  useEffect(() => {
    setImagesLoaded({});
    setFourthRowElement(null);
    setObserverReady(false); // Disable observer until scroll completes
    window.scrollTo({ top: 0, behavior: "instant" });

    // Wait for scroll to complete before enabling observer
    const timer = setTimeout(() => {
      setObserverReady(true);
    }, 500);

    if (imageType === "anime") {
      setLoadedAnimeCount(10);
    } else if (imageType === "render") {
      setLoadedRenderCount(10);
    }

    return () => clearTimeout(timer);
  }, [imageType]);

  // Callbacks for handlers - using DOM manipulation for zero re-renders
  const handleToggleImage = useCallback((imageId: string) => {
    const clickedElement = document.querySelector(`[data-image-id="${imageId}"]`);
    const currentActive = document.querySelector("[data-image-id].active");
    if (currentActive === clickedElement) {
      // Clicking the same item - deactivate
      currentActive?.classList.remove("active");
      currentActive?.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
      currentActive?.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
      currentActive?.querySelector(".gallery-button")?.classList.remove("!opacity-100");
    } else {
      // Remove active from previous item
      currentActive?.classList.remove("active");
      currentActive?.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
      currentActive?.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
      currentActive?.querySelector(".gallery-button")?.classList.remove("!opacity-100");

      // Add active to new item
      clickedElement?.classList.add("active");
      clickedElement?.querySelector(".gallery-overlay")?.classList.add("!opacity-100");
      clickedElement?.querySelector(".gallery-ring")?.classList.add("!ring-gold");
      clickedElement?.querySelector(".gallery-button")?.classList.add("!opacity-100");
    }
  }, []);
  const handleToggleVideo = useCallback((videoId: string) => {
    const clickedElement = document.querySelector(`[data-video-id="${videoId}"]`);
    const currentActive = document.querySelector("[data-video-id].active");
    if (currentActive === clickedElement) {
      // Clicking the same item - deactivate
      currentActive?.classList.remove("active");
      currentActive?.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
      currentActive?.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
      currentActive?.querySelector(".gallery-button")?.classList.remove("!opacity-100");
    } else {
      // Remove active from previous item
      currentActive?.classList.remove("active");
      currentActive?.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
      currentActive?.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
      currentActive?.querySelector(".gallery-button")?.classList.remove("!opacity-100");

      // Add active to new item
      clickedElement?.classList.add("active");
      clickedElement?.querySelector(".gallery-overlay")?.classList.add("!opacity-100");
      clickedElement?.querySelector(".gallery-ring")?.classList.add("!ring-gold");
      clickedElement?.querySelector(".gallery-button")?.classList.add("!opacity-100");
    }
  }, []);
  const handleImageLoad = useCallback(
    (index: number) => {
      setImagesLoaded((prev) => ({
        ...prev,
        [index]: true,
      }));

      // Progressive loading
      if (imageType === "anime" && index >= loadedAnimeCount - 3 && loadedAnimeCount < animeImages.length) {
        setTimeout(() => setLoadedAnimeCount((prev) => Math.min(prev + 5, animeImages.length)), 200);
      }
      if (imageType === "render" && index >= loadedRenderCount - 3 && loadedRenderCount < renderImages.length) {
        setTimeout(() => setLoadedRenderCount((prev) => Math.min(prev + 5, renderImages.length)), 200);
      }
    },
    [imageType, loadedAnimeCount, loadedRenderCount],
  );
  const handleVideoPlaying = useCallback(
    (index: number) => {
      if (index === loadedVideoCount - 1 && loadedVideoCount < galleryVideos.length) {
        setLoadedVideoCount((prev) => prev + 1);
      }
    },
    [loadedVideoCount],
  );

  // Handler for login required actions
  const handleLoginRequired = useCallback((redirectPath: string, redirectState?: Record<string, unknown>) => {
    setLoginRedirect({ path: redirectPath, state: redirectState });
    setIsLoginPromptOpen(true);
  }, []);

  // Reset active image when switching tabs or image types
  useEffect(() => {
    // Remove active classes from all items
    document.querySelectorAll("[data-image-id].active, [data-video-id].active").forEach((el) => {
      el.classList.remove("active");
      el.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
      el.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
      el.querySelector(".gallery-button")?.classList.remove("!opacity-100");
    });
  }, [activeTab, imageType]);

  // Close active image when clicking outside - optimized with delay
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      // Close if clicking outside gallery images/videos
      if (!target.closest("[data-gallery-image]") && !target.closest("[data-gallery-video]")) {
        // Remove active from all items
        document.querySelectorAll("[data-image-id].active, [data-video-id].active").forEach((el) => {
          el.classList.remove("active");
          el.querySelector(".gallery-overlay")?.classList.remove("!opacity-100");
          el.querySelector(".gallery-ring")?.classList.remove("!ring-gold");
          el.querySelector(".gallery-button")?.classList.remove("!opacity-100");
        });
      }
    };

    // Small delay to avoid conflicts with item clicks
    const timeoutId = setTimeout(() => {
      document.addEventListener("click", handleClickOutside);
    }, 100);
    return () => {
      clearTimeout(timeoutId);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Static gradient background - optimized for performance */}
      <div className="fixed inset-0 bg-gradient-to-br from-[#0D0D0D] via-[#1a0a0f] to-[#0D0D0D]">
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-transparent to-transparent opacity-90"></div>
      </div>

      <Particles />
      <Navigation />

      {/* Age Restriction Modal - shown when not logged in and age not confirmed */}
      {!loading && !user && !ageConfirmed && <AgeRestrictionModal isOpen={true} />}

      <AppSidebar>
        <main className="pt-20 relative z-10 overflow-x-hidden">
          <div className="w-full px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
              <div className="text-center mb-12">
                <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-yellow-500 to-orange-600 mb-4"></h1>
                <p className="text-xl text-muted-foreground max-w-2xl mx-auto"></p>

                {/* Tab buttons */}
                <div className="flex justify-center gap-4 mt-8">
                  <Button
                    variant={activeTab === "images" ? "gradient" : "outline"}
                    onClick={() => setActiveTab("images")}
                    className="px-8"
                  >
                    Images ({realisticImages.length + animeImages.length + renderImages.length})
                  </Button>
                  <Button
                    variant={activeTab === "videos" ? "gradient" : "outline"}
                    onClick={() => setActiveTab("videos")}
                    className="px-8"
                  >
                    Videos ({galleryVideos.length})
                  </Button>
                </div>

                {/* Image type selection - only visible when images tab is active */}
                {activeTab === "images" && (
                  <div className="flex justify-center gap-3 mt-6 animate-fade-in">
                    <Button
                      variant={imageType === "realistic" ? "default" : "outline"}
                      onClick={() => setImageType("realistic")}
                      className={imageType === "realistic" ? "gradient-premium border-gold" : ""}
                      size="sm"
                    >
                      realistic ({realisticImages.length})
                    </Button>
                    <Button
                      variant={imageType === "anime" ? "default" : "outline"}
                      onClick={() => setImageType("anime")}
                      className={imageType === "anime" ? "gradient-premium border-gold" : ""}
                      size="sm"
                    >
                      Anime ({animeImages.length})
                    </Button>
                    <div className="relative">
                      <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded z-10">
                        NEW
                      </span>
                      <Button
                        variant={imageType === "render" ? "default" : "outline"}
                        onClick={() => setImageType("render")}
                        className={imageType === "render" ? "gradient-premium border-gold" : ""}
                        size="sm"
                      >
                        Render ({renderImages.length})
                      </Button>
                    </div>
                  </div>
                )}
              </div>

              {/* Gallery Grid - Grid layout para carregamento horizontal */}
              <div
                className={`grid gap-4 min-w-0 w-full ${activeTab === "videos" ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" : "grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5"}`}
              >
                {activeTab === "images"
                  ? currentImages.map((item, idx) => (
                      <div key={item.id} ref={idx === 12 ? fourthRowCallback : undefined}>
                        <GalleryImageItem
                          imageUrl={item.url}
                          imageId={item.id}
                          index={item.index}
                          onToggle={handleToggleImage}
                          onImageLoad={handleImageLoad}
                          user={user}
                          onLoginRequired={handleLoginRequired}
                        />
                      </div>
                    ))
                  : videoData.map((item) => (
                      <GalleryVideoItemWrapper
                        key={item.id}
                        videoUrl={item.url}
                        videoId={item.id}
                        index={item.index}
                        onToggle={handleToggleVideo}
                        onPlaying={() => handleVideoPlaying(item.index)}
                        pauseWhenPopupOpen={isAnyPopupOpen}
                        user={user}
                        onLoginRequired={handleLoginRequired}
                      />
                    ))}
              </div>

              {/* FAQ Section */}
              <GalleryFAQ />
            </div>
          </div>
        </main>

        <LegalDisclaimer />
        <Footer />

        <PricingModal isOpen={isPricingOpen} onClose={() => setIsPricingOpen(false)} />

        <ImagePopup
          isOpen={isImagePopupOpen}
          onClose={() => setIsImagePopupOpen(false)}
          imageType={imageType}
          onAction={() => {
            if (!user) {
              setLoginRedirect({ path: "/generator" });
              setIsLoginPromptOpen(true);
            } else {
              navigate("/generator");
            }
          }}
        />

        <LoginPromptModal
          isOpen={isLoginPromptOpen}
          onClose={() => {
            setIsLoginPromptOpen(false);
            setLoginRedirect(null);
          }}
          redirectPath={loginRedirect?.path}
          redirectState={loginRedirect?.state}
        />

        {/* Floating Create Now Button - Mobile Only */}
        <Link to={activeTab === "videos" ? "/video-generator" : "/generator"}></Link>
      </AppSidebar>
    </div>
  );
};
export default Gallery;
